var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rate-label"},[_c('p',{staticClass:"rate-label_name"},[_vm._v(_vm._s(_vm.name))]),_c('p',{staticClass:"rate-label_number"},[_vm._v(_vm._s(_vm.rate))])])
}
var staticRenderFns = []

export { render, staticRenderFns }